module.exports = __webpack_public_path__ + "img/map-active.0bbfdda0.png";